import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    errorMessage: (count: number) => string | React.ReactNode;
    warningMessage: string;
    downloadWarningContinue: string;
    downloadWarningDetails: string;
    downloadWarningDismiss: string;
    downloadWarningTitle: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            errorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "WarningModal.errorMessage?c=1ajpwrqvzr0h3", defaultMessage: "{count, plural, one {Couldn''t download {count} item} other {Couldn''t download {count} items}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            warningMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WarningModal.warningMessage?c=2yeq6gkvctgaw", defaultMessage: "Some files could not be downloaded." }));
                },
                enumerable: true,
                configurable: true
            },
            downloadWarningContinue: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WarningModal.downloadWarningContinue?c=lmf4jegcl01i", defaultMessage: "Continue" }));
                },
                enumerable: true,
                configurable: true
            },
            downloadWarningDetails: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WarningModal.downloadWarningDetails?c=3geocvqbibgcs", defaultMessage: "Folder structure will not be retained. All files will be downloaded individually." }));
                },
                enumerable: true,
                configurable: true
            },
            downloadWarningDismiss: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WarningModal.downloadWarningDismiss?c=12vpt6ppn1wyz", defaultMessage: "Dismiss" }));
                },
                enumerable: true,
                configurable: true
            },
            downloadWarningTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WarningModal.downloadWarningTitle?c=9wwqhebc3e77", defaultMessage: "Continue with download?" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
